import React from "react";
import ReactPlayer from "react-player";
import { LazyLoadImage } from "react-lazy-load-image-component";

import Modal from "../../components/blocks/Modal";
import { getCookie } from "../../components/Cookie";
import Offer from "../../components/blocks/Offer";

class About extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      show: false,
    };
    this.click = this.click.bind(this);
  }
  click() {
    var that = this;

    this.setState({ show: true });

    var prevHeight = this.refs.myImgContainer.offsetHeight;

    setTimeout(function () {
      that.props.click(that.refs.myImgContainer.offsetHeight - prevHeight);
    }, 80);
  }

  render() {
    return (
      <span className={this.state.show ? "order-includes" : "order-includes"}>
        <span
          dangerouslySetInnerHTML={{
            __html:
              "<span>" +
              (this.state.show
                ? this.props.text
                : this.props.text.split(" ").splice(0, 20).join(" ") + "...") +
              "</span>",
          }}
          ref="myImgContainer"
        ></span>

        {!this.state.show ? (
          <span onClick={this.click} className="view-more">
            view more
          </span>
        ) : null}
      </span>
    );
  }
}

class Package extends React.PureComponent {
  render() {
    var styles = {};

    var arr = this.props.data.content;

    let elements = [];

    for (let i = 0; i < arr.length; i++) {
      elements.push(
        <li className="cntnt" key={i}>
          <span>{arr[i]}</span>
        </li>
      );
    }

    if (this.props.data.gift) {
      elements.push(
        <li className="gift" key={arr.length}>
          {this.props.data.gift}
        </li>
      );
    }

    return (
      <span className="order-includes collapsed" ref="myImgContainer">
        <span className="order-title">Order Includes</span>

        <ul className={"column-" + this.props.columns}>{elements}</ul>
      </span>
    );
  }
}

class MultiService extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      show: true,
      oHeight: 0,
      height: "auto",
      showModal: false,
      showModal2: false,
      playing: false,
      showPrices:
        getCookie("weprodigi-pro") || window.location.search.indexOf("pro") > -1
          ? false
          : true,
    };

    this.action = this.action.bind(this);

    this.hideModal = this.hideModal.bind(this);

    this.showModal = this.showModal.bind(this);

    this.hideModal2 = this.hideModal2.bind(this);

    this.showModal2 = this.showModal2.bind(this);

    this.play = this.play.bind(this);

    this.pause = this.pause.bind(this);

    this.isInViewport = this.isInViewport.bind(this);

    this.packageClick = this.packageClick.bind(this);
  }
  play() {
    this.setState({ playing: true });
  }
  pause() {
    this.setState({ playing: false });
  }

  action() {
    if (window.innerWidth < 1000) {
      if (!this.state.show) {
        this.setState({ height: this.state.oHeight });
      } else {
        this.setState({ height: 0 });

        this.pause();
      }

      this.setState({ show: !this.state.show });
    }
  }
  hideModal() {
    this.setState({ showModal: false });
  }
  showModal(e) {
    e.preventDefault();
    this.setState({ showModal: true });
  }
  showModal2() {
    this.setState({ showModal: false });
    this.setState({ showModal2: true });
  }
  hideModal2() {
    this.setState({ showModal2: false });
  }
  isInViewport(offset = 0) {
    if (!this.yourElement) return false;
    const top = this.yourElement.getBoundingClientRect().top;

    return top + offset >= 0 && top - offset <= window.innerHeight;
  }

  componentDidMount() {
    var that = this;

    if (window.innerWidth < 1000) {
      const height = that.divElement.clientHeight;

      that.setState({ height: height });

      that.setState({ oHeight: height });
    }

    this._int = setInterval(function () {
      if (!that.isInViewport(60)) {
        that.pause();
      }
    }, 100);
  }

  packageClick(height) {
    this.setState({ height: this.state.height + height });
    this.setState({ oHeight: this.state.oHeight + height });
  }

  render() {
    var preview = "";

    if (this.props.preview_type === "video") {
      preview = (
        <div className="react-player">
          <video
            key={this.props.preview.url}
            width="100%"
            height="100%"
            poster={this.props.preview.poster}
            controls
          >
            <source src={this.props.preview.url} type="video/mp4"></source>
          </video>
        </div>
      );
    } else if (this.props.preview_type === "image") {
      preview = (
        <LazyLoadImage
          src={this.props.preview}
          alt={this.props.titleNode}
        ></LazyLoadImage>
      );
    } else if (this.props.preview_type === "iframe") {
      preview = (
        <iframe
          title={this.props.title}
          src={this.props.preview}
          frameBorder="0"
          width="100%"
          height="250"
        ></iframe>
      );
    }

    return (
      <div className="multiservice" id={this.props.id}>
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <p className="multiservices-title" onClick={this.action}>
                {this.props.title}{" "}
                {this.props.badge ? (
                  <span className="badge">Bestseller</span>
                ) : (
                  <span className={this.props.icon}></span>
                )}{" "}
              </p>
            </div>
          </div>

          <div
            className={"row collapse" + (this.state.show ? " show" : "")}
            style={{ height: this.state.height }}
            ref={(divElement) => {
              this.divElement = divElement;
            }}
          >
            <div className="col-lg-5">
              <div
                ref={(el) => (this.yourElement = el)}
                className={
                  this.props.preview_aspect.type === "ratio"
                    ? "preview preview-" + this.props.preview_aspect.num
                    : "preview preview-" + this.props.preview_aspect.height
                }
              >
                {preview}
                {this.props.animation}
              </div>
            </div>
            <div className="col-lg-7">
              <span className="multiservices-desc">
                {this.props.order ? (
                  <>
                    {
                      <About
                        click={this.packageClick}
                        text={this.props.about}
                      ></About>
                    }
                    <Package
                      columns={this.props.order.columns}
                      click={this.packageClick}
                      data={this.props.order}
                    ></Package>{" "}
                  </>
                ) : (
                  this.props.about
                )}
              </span>

              {this.state.showPrices && !this.props.hidePrice && (
                <p className="starting-from">
                  {this.props.price_title
                    ? this.props.price_title
                    : "Starting from"}
                  <span className="line-break-desktop"></span>
                  <span className="price">
                    {this.props.price[this.props.currency]}
                  </span>
                </p>
              )}

              <a
                className="button get-offer-button"
                onClick={(e) =>
                  this.props.quote && this.props.quote.startQuote
                    ? this.props.quote.startQuote(e)
                    : this.showModal(e)
                }
              >
                {this.props.quote ? this.props.quote.text : "Get Offer"}
              </a>

              {this.props.actionButton ? (
                <a
                  rel="noopener noreferrer nofollow"
                  href={this.props.actionButtonLink}
                  target="_blank"
                  className="button purple see-example-button"
                >
                  {this.props.actionButtonText}
                </a>
              ) : (
                ""
              )}
            </div>

            <Offer
              country={this.props.country}
              callBack={this.showModal2}
              hide={this.hideModal}
              show={this.state.showModal}
              service={this.props.titleNode}
            ></Offer>

            <Modal
              show={this.state.showModal2}
              hide={this.hideModal2}
              service="offer"
              loaded={true}
            ></Modal>

            {/* <Link
                            href="#"
                            target="_self"
                            icon={'arrow arrow-' +this.props.aligment}
                            ></Link> */}
          </div>
        </div>
      </div>
    );
  }
}

export default MultiService;
